import React, { useEffect, useState } from "react";

const CookieConsentModal: React.FC = () => {
  const [showConsentModal, setShowConsentModal] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      const timer = setTimeout(() => {
        setShowConsentModal(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAcceptCookies = () => {
    localStorage.setItem('cookieConsent', 'true');
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
        analytics_storage: 'granted',
      });
    }
    setShowConsentModal(false);
  };

  if (!showConsentModal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center p-4">
      <div className="w-full max-w-xl rounded-xl bg-white p-6 shadow-2xl backdrop-blur-md transition-all duration-300 ease-in-out dark:bg-gray-800 md:max-w-4xl">
        <div className="flex flex-col">
          <div className="w-full">
            <h3 className="text-xl font-bold text-gray-900 dark:text-white">We use cookies</h3>
            <p className="mt-2 text-base text-gray-600 dark:text-gray-400 text-justify">
              This website uses cookies to ensure you get the best experience on our website. By using our site, you agree to our use of cookies.
            </p>
            <a href="/privacy-policy" className="ml-1 font-semibold text-blue-700 hover:text-blue-800 dark:text-blue-400">Read our privacy policy</a>
          </div>
          <div className="mt-4 w-full">
            <button
              onClick={handleAcceptCookies}
              className="w-full rounded-lg bg-black px-5 py-2.5 text-center text-sm font-medium text-white shadow-lg transition-all duration-300 ease-in-out hover:bg-gray-800 focus:outline-none focus:ring-4 focus:ring-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600"
            >
              Accept Cookies
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentModal;
